module.exports = __webpack_public_path__ + "static/media/ios-radio.a8474262.svg";